/**
 * Analytics module - All analytics removed
 * These are no-op stubs to maintain API compatibility
 */

export const setup = async () => {}

export const pageView = () => {}

export const modalView = () => {}

export const SIGNUP_METHODS = {}

export const SIGNUP_ACTIONS = {}

export const event = () => {}

export const rawGtag = () => {}

export const setUser = () => {}

export const KeyActions = {
  Assistant: {}
}

export const keyAction = () => {}

export const useKeyActionLoading = () => {}

export const useKeyActionTimeSpent = () => {}
